<template>
  <span v-if="issue.state === 'open'">☐</span
  ><span v-if="issue.state === 'closed'">☑</span>
  {{ issue.title }}
  <span v-if="issue.pin_order">(#{{ issue.pin_order }})</span>
  <span v-if="issue.comments"
    ><v-icon icon="mdi-comment" /> {{ issue.comments }}</span
  >
</template>
<script setup lang="ts">
import type { Issue } from "../gen/forgejo-vue";
defineProps<{
  issue: Issue;
}>();
</script>
